import { useEffect } from "react";
import { useSiteContent } from "@/lib/siteContent";

/**
 * Mounts the Google Analytics gtag.js snippet when a measurement ID
 * (e.g., "G-XXXXXXX" or legacy "UA-...") is configured in admin.
 * Safe to mount multiple times — no-ops if ID is unchanged.
 */
export default function GoogleAnalytics() {
  const { content } = useSiteContent();
  const id = (content?.site?.googleAnalyticsId || "").trim();

  useEffect(() => {
    if (!id) return;
    if (document.querySelector(`script[data-ga-id="${id}"]`)) return;

    const s1 = document.createElement("script");
    s1.async = true;
    s1.src = `https://www.googletagmanager.com/gtag/js?id=${id}`;
    s1.setAttribute("data-ga-id", id);
    document.head.appendChild(s1);

    const s2 = document.createElement("script");
    s2.setAttribute("data-ga-id", id);
    s2.text = `window.dataLayer = window.dataLayer || [];
function gtag(){dataLayer.push(arguments);}
gtag('js', new Date());
gtag('config', '${id}', { anonymize_ip: true });`;
    document.head.appendChild(s2);
  }, [id]);

  return null;
}
